export const gridObj = [
    {
        id: 1,
        SentDate: "04/05/2022 12:59 PM",
        SentFrom: "mike_jordan@centene.test.directaddress.com",
        SentTo: "ses-admin@centene.test.directaddress.com",
        MessageType: "Not MDN",
        Status: "Confirmed",
        DateTimeAccepted: "04/05/2022 12:59 PM",
        DateTimeConfirmed: "04/05/2022 12:59 PM",
        ExtStatus: "--",
        Username: "michelle_doe123",
        FullName: "Michelle Doe",
        DirectEmail: "michelle_doe123@sestest.directaddress.com",
        LastLogin: "04/05/2022 12:59 PM",
        LastModified: "04/05/2022 12:59 PM",
        ModifiedBy: "SESAdmin",
        DateCreated: "04/05/2022 12:59 PM",
        CreatedBy: "SESAdmin",
        ActivityDate: "04/05/2022 12:59 PM",
        ActivityStatus: "Completed",
        ActivityType: "User Account Updated",
        DateTimeDeleted: "04/05/2022 12:59 PM",
        DeletedReason: "Cannot get through Experian",
        DeletedBy: "SESAdmin",
        Org: "Centene",
        MailboxSize: "300MB",
        FwdEmail: "steve_doe123@sestest.directaddress.com",
        StartDate: "04/05/2022 12:59 PM",
        EndDate: "--",
        FwdStatus: "Active",
        FileName: "ARMC 4.25.23",
        ReportType: "Received Messages Report",
        StartedBy: "chara.mcmunn2",
        DownloadStatus: "Ready",
        Domain: "service2.directaddress.net",
        UploadType: "Add User",
        UploadStatus: "In Progress",
    },
    {
        Id: 2,
        SentDate: "04/05/2022 12:59 PM",
        SentFrom: "sambrooks@centene.test.directaddress.com",
        SentTo: "ses-admin@centene.test.directaddress.com",
        MessageType: "MDN",
        Status: "Confirmed",
        ExtStatus: "--",
        DateTimeAccepted: "04/05/2022 12:59 PM",
        DateTimeConfirmed: "04/05/2022 12:59 PM",
        Username: "kevin_doe123",
        FullName: "Kevin Doe",
        DirectEmail: "kevin_doe123@sestest.directaddress.com",
        LastLogin: "04/05/2022 12:59 PM",
        LastModified: "04/05/2022 12:59 PM",
        ModifiedBy: "SESAdmin",
        DateCreated: "04/05/2022 12:59 PM",
        CreatedBy: "SESAdmin",
        ActivityDate: "04/05/2022 12:59 PM",
        ActivityStatus: "Contact Details Completed",
        ActivityType: "User Account Updated",
        DateTimeDeleted: "04/05/2022 12:59 PM",
        DeletedReason: "Cannot get through Experian",
        DeletedBy: "SESAdmin",
        Org: "sample org",
        MailboxSize: "300MB",
        FwdEmail: "steve_doe123@sestest.directaddress.com",
        StartDate: "04/05/2022 12:59 PM",
        EndDate: "04/05/2022 12:59 PM",
        FwdStatus: "Paused",
        FileName: "ARMC 4.25.23",
        ReportType: "Sent Messages Report",
        StartedBy: "SESAdmin",
        DownloadStatus: "Ready",
        Domain: "test.direct.abilitynetwork.com",
        UploadType: "Organization",
        UploadStatus: "Completed"
    },
    {
        Id: 3,
        SentDate: "04/05/2022 12:59 PM",
        SentFrom: "sesreston@centene.test.directaddress.com",
        SentTo: "ses-admin@centene.test.directaddress.com",
        MessageType: "MDN",
        Status: "Failed",
        ExtStatus:
            "Certificate has expired. Begin: 2/21/2019 5:00:36 PM End: 2/21/2020 5:05:36 PM",
        DateTimeAccepted: "--",
        DateTimeConfirmed: "--",
        Username: "eric_doe123",
        FullName: "Eric Doe",
        DirectEmail: "eric_doe123@sestest.directaddress.com",
        LastLogin: "04/05/2022 12:59 PM",
        LastModified: "04/05/2022 12:59 PM",
        ModifiedBy: "SESAdmin",
        DateCreated: "04/05/2022 12:59 PM",
        CreatedBy: "SESAdmin",
        ActivityDate: "04/05/2022 12:59 PM",
        ActivityStatus: "Contact Details Completed",
        ActivityType: "User Account Updated",
        DateTimeDeleted: "04/05/2022 12:59 PM",
        DeletedReason: "Cannot get through Experian",
        DeletedBy: "SESAdmin",
        Org: "Centene",
        MailboxSize: "300MB",
        FwdEmail: "steve_doe123@sestest.directaddress.com",
        StartDate: "04/05/2022 12:59 PM",
        EndDate: "--",
        FwdStatus: "Active",
        FileName: "ReceivedMessageStatus",
        ReportType: "Sent Messages Report",
        StartedBy: "schakravarty.optumrecall",
        DownloadStatus: "In Progress",
        Domain: "test.yourcarecommunity.org",
        UploadType: "Organization Email",
        UploadStatus: "In Progress"
    },
    {
        Id: 4,
        SentDate: "04/05/2022 12:59 PM",
        SentFrom: "kelly_bigwave@centene.test.directaddress.com",
        SentTo: "ses-admin@centene.test.directaddress.com",
        MessageType: "Not MDN",
        Status: "Failed",
        ExtStatus:
            "Certificate has expired. Begin: 2/21/2019 5:00:36 PM End: 2/21/2020 5:05:36 PM",
        DateTimeAccepted: "--",
        DateTimeConfirmed: "--",
        Username: "harry_doe123",
        FullName: "Harry Doe",
        DirectEmail: "harry_doe123@sestest.directaddress.com",
        LastLogin: "04/05/2022 12:59 PM",
        LastModified: "04/05/2022 12:59 PM",
        ModifiedBy: "SESAdmin",
        DateCreated: "04/05/2022 12:59 PM",
        CreatedBy: "SESAdmin",
        ActivityDate: "04/05/2022 12:59 PM",
        ActivityStatus: "NPI Completed",
        ActivityType: "User Account Updated",
        DateTimeDeleted: "04/05/2022 12:59 PM",
        DeletedReason: "Cannot get through Experian",
        DeletedBy: "SESAdmin",
        Org: "Centene",
        MailboxSize: "300MB",
        FwdEmail: "steve_doe123@sestest.directaddress.com",
        StartDate: "04/05/2022 12:59 PM",
        EndDate: "--",
        FwdStatus: "Active",
        FileName: "BriovaUAT MDN",
        ReportType: "Sent Messages Report",
        StartedBy: "SESAdmin",
        DownloadStatus: "In Progress",
        Domain: "test.direct.abilitynetwork.com",
        UploadType: "Delete User",
        UploadStatus: "In Progress"
    },
    {
        Id: 5,
        SentDate: "04/05/2022 12:59 PM",
        SentFrom: "jamesymore@centene.test.directaddress.com",
        SentTo: "ses-admin@centene.test.directaddress.com",
        MessageType: "MDN",
        Status: "Confirmed",
        ExtStatus: "--",
        DateTimeAccepted: "04/05/2022 12:59 PM",
        DateTimeConfirmed: "04/05/2022 12:59 PM",
        Username: "steve_doe123",
        FullName: "Steve Doe",
        DirectEmail: "steve_doe123@sestest.directaddress.com",
        LastLogin: "04/05/2022 12:59 PM",
        LastModified: "04/05/2022 12:59 PM",
        ModifiedBy: "SESAdmin",
        DateCreated: "04/05/2022 12:59 PM",
        CreatedBy: "SESAdmin",
        ActivityDate: "04/05/2022 12:59 PM",
        ActivityStatus: "Contact Details Completed",
        ActivityType: "User Account Updated",
        DateTimeDeleted: "04/05/2022 12:59 PM",
        DeletedReason: "Cannot get through Experian",
        DeletedBy: "SESAdmin",
        Org: "Sub-sub-Centene",
        MailboxSize: "300MB",
        FwdEmail: "steve_doe123@sestest.directaddress.com",
        StartDate: "04/05/2022 12:59 PM",
        EndDate: "04/05/2022 12:59 PM",
        FwdStatus: "Deleted",
        FileName: "armc-ecr sent",
        ReportType: "Sent Messages Report",
        StartedBy: "SESAdmin",
        DownloadStatus: "Ready",
        Domain: "test.direct.abilitynetwork.com",
        UploadType: "Organization Email",
        UploadStatus: "Completed"
    },
    {
        Id: 6,
        SentDate: "04/05/2022 12:59 PM",
        SentFrom: "robertwoods@centene.test.directaddress.com",
        SentTo: "ses-admin@centene.test.directaddress.com",
        MessageType: "Not MDN",
        Status: "Failed",
        ExtStatus:
            "Certificate has expired. Begin: 2/21/2019 5:00:36 PM End: 2/21/2020 5:05:36 PM",
        DateTimeAccepted: "--",
        DateTimeConfirmed: "--",
        Username: "willy_doe123",
        FullName: "Willy Doe",
        DirectEmail: "willy_doe123@sestest.directaddress.com",
        LastLogin: "04/05/2022 12:59 PM",
        LastModified: "04/05/2022 12:59 PM",
        ModifiedBy: "SESAdmin",
        DateCreated: "04/05/2022 12:59 PM",
        CreatedBy: "SESAdmin",
        ActivityDate: "04/05/2022 12:59 PM",
        ActivityStatus: "Completed",
        ActivityType: "User Account Updated",
        DateTimeDeleted: "04/05/2022 12:59 PM",
        DeletedReason: "Cannot get through Experian",
        DeletedBy: "SESAdmin",
        Org: "Centene",
        MailboxSize: "300MB",
        FwdEmail: "steve_doe123@sestest.directaddress.com",
        StartDate: "04/05/2022 12:59 PM",
        EndDate: "04/05/2022 12:59 PM",
        FwdStatus: "Paused",
        FileName: "caromont received",
        ReportType: "Sent Messages Report",
        StartedBy: "SESAdmin",
        DownloadStatus: "Failed",
        Domain: "test.direct.abilitynetwork.com",
        UploadType: "Add User",
        UploadStatus: "Completed"
    },
    {
        Id: 7,
        SentDate: "04/05/2022 12:59 PM",
        SentFrom: "jackie_gleeson@centene.test.directaddress.com",
        SentTo: "ses-admin@centene.test.directaddress.com",
        MessageType: "Not MDN",
        Status: "Failed",
        ExtStatus:
            "Certificate has expired. Begin: 2/21/2019 5:00:36 PM End: 2/21/2020 5:05:36 PM",
        DateTimeAccepted: "--",
        DateTimeConfirmed: "--",
        Username: "jackie_doe123",
        FullName: "Jackie Doe",
        DirectEmail: "jackie_doe123@sestest.directaddress.com",
        LastLogin: "04/05/2022 12:59 PM",
        LastModified: "04/05/2022 12:59 PM",
        ModifiedBy: "SESAdmin",
        DateCreated: "04/05/2022 12:59 PM",
        CreatedBy: "SESAdmin",
        ActivityDate: "04/05/2022 12:59 PM",
        ActivityStatus: "Contact Details Completed",
        ActivityType: "User Account Updated",
        DateTimeDeleted: "04/05/2022 12:59 PM",
        DeletedReason: "Cannot get through Experian",
        DeletedBy: "SESAdmin",
        Org: "Humana",
        MailboxSize: "300MB",
        FwdEmail: "steve_doe123@sestest.directaddress.com",
        StartDate: "04/05/2022 12:59 PM",
        EndDate: "04/05/2022 12:59 PM",
        FwdStatus: "Paused",
        FileName: "TESTREPORT",
        ReportType: "Sent Messages Report",
        StartedBy: "SESAdmin",
        DownloadStatus: "Ready",
        Domain: "test.direct.abilitynetwork.com",
        UploadType: "Add User",
        UploadStatus: "Completed"
    },
    {
        Id: 8,
        SentDate: "04/05/2022 12:59 PM",
        SentFrom: "sesadmin@centene.test.directaddress.com",
        SentTo: "ses-admin@centene.test.directaddress.com",
        MessageType: "Not MDN",
        Status: "Failed",
        ExtStatus:
            "Certificate has expired. Begin: 2/21/2019 5:00:36 PM End: 2/21/2020 5:05:36 PM",
        DateTimeAccepted: "--",
        DateTimeConfirmed: "--",
        Username: "brian_doe123",
        FullName: "Brian Doe",
        DirectEmail: "brian_doe123@sestest.directaddress.com",
        LastLogin: "04/05/2022 12:59 PM",
        LastModified: "04/05/2022 12:59 PM",
        ModifiedBy: "SESAdmin",
        DateCreated: "04/05/2022 12:59 PM",
        CreatedBy: "SESAdmin",
        ActivityDate: "04/05/2022 12:59 PM",
        ActivityStatus: "NPI Completed",
        ActivityType: "User Account Updated",
        DateTimeDeleted: "04/05/2022 12:59 PM",
        DeletedReason: "Cannot get through Experian",
        DeletedBy: "SESAdmin",
        Org: "Sample Org",
        MailboxSize: "300MB",
        FwdEmail: "steve_doe123@sestest.directaddress.com",
        StartDate: "04/05/2022 12:59 PM",
        EndDate: "04/05/2022 12:59 PM",
        FwdStatus: "Deleted",
        FileName: "Reg API Testing",
        ReportType: "Sent Messages Report",
        StartedBy: "SESAdmin",
        DownloadStatus: "Failed",
        Domain: "test.direct.abilitynetwork.com",
        UploadType: "Organization Email",
        UploadStatus: "Completed"
    },
    {
        Id: 9,
        SentDate: "04/05/2022 12:59 PM",
        SentFrom: "earljones@centene.test.directaddress.com",
        SentTo: "ses-admin@centene.test.directaddress.com",
        MessageType: "Not MDN",
        Status: "Confirmed",
        ExtStatus: "--",
        DateTimeAccepted: "04/05/2022 12:59 PM",
        DateTimeConfirmed: "04/05/2022 12:59 PM",
        Username: "katy_doe123",
        FullName: "Kay Doe",
        DirectEmail: "katy_doe123@sestest.directaddress.com",
        LastLogin: "04/05/2022 12:59 PM",
        LastModified: "04/05/2022 12:59 PM",
        ModifiedBy: "SESAdmin",
        DateCreated: "04/05/2022 12:59 PM",
        CreatedBy: "SESAdmin",
        ActivityDate: "04/05/2022 12:59 PM",
        ActivityStatus: "Contact Details Completed",
        ActivityType: "User Account Updated",
        DateTimeDeleted: "04/05/2022 12:59 PM",
        DeletedReason: "Cannot get through Experian",
        DeletedBy: "SESAdmin",
        Org: "Sample Org",
        MailboxSize: "300MB",
        FwdEmail: "steve_doe123@sestest.directaddress.com",
        StartDate: "04/05/2022 12:59 PM",
        EndDate: "--",
        FwdStatus: "Active",
        FileName: "to_rrfront_qa2",
        ReportType: "Sent Messages Report",
        StartedBy: "SESAdmin",
        DownloadStatus: "Ready",
        Domain: "test.direct.abilitynetwork.com",
        UploadType: "Delete User",
        UploadStatus: "Failed"
    },

    {
        Id: 10,
        SentDate: "04/05/2022 12:59 PM",
        SentFrom: "wilsonworks@centene.test.directaddress.com",
        SentTo: "ses-admin@centene.test.directaddress.com",
        MessageType: "Not MDN",
        Status: "Confirmed",
        ExtStatus: "--",
        DateTimeAccepted: "04/05/2022 12:59 PM",
        DateTimeConfirmed: "04/05/2022 12:59 PM",
        Username: "emilly_doe123",
        FullName: "Emilly Doe",
        DirectEmail: "emilly_doe123@sestest.directaddress.com",
        LastLogin: "04/05/2022 12:59 PM",
        LastModified: "04/05/2022 12:59 PM",
        ModifiedBy: "SESAdmin",
        DateCreated: "04/05/2022 12:59 PM",
        CreatedBy: "SESAdmin",
        ActivityDate: "04/05/2022 12:59 PM",
        ActivityStatus: "Completed",
        ActivityType: "User Account Updated",
        DateTimeDeleted: "04/05/2022 12:59 PM",
        DeletedReason: "Cannot get through Experian",
        DeletedBy: "SESAdmin",
        Org: "Sample Org",
        MailboxSize: "300MB",
        FwdEmail: "steve_doe123@sestest.directaddress.com",
        StartDate: "04/05/2022 12:59 PM",
        EndDate: "--",
        FwdStatus: "Active",
        FileName: "check_after_sending",
        ReportType: "Sent Messages Report",
        StartedBy: "SESAdmin",
        DownloadStatus: "Ready",
        Domain: "test.direct.abilitynetwork.com",
        UploadType: "Add User",
        UploadStatus: "In Progress"
    },
    {
        Id: 11,
        SentDate: "04/05/2022 12:59 PM",
        SentFrom: "marytylormore@centene.test.directaddress.com",
        SentTo: "ses-admin@centene.test.directaddress.com",
        MessageType: "Not MDN",
        Status: "Confirmed",
        ExtStatus: "--",
        DateTimeAccepted: "04/05/2022 12:59 PM",
        DateTimeConfirmed: "04/05/2022 12:59 PM",
        Username: "mike_doe123",
        FullName: "Mike Doe",
        DirectEmail: "mike_doe123@sestest.directaddress.com",
        LastLogin: "04/05/2022 12:59 PM",
        LastModified: "04/05/2022 12:59 PM",
        ModifiedBy: "SESAdmin",
        DateCreated: "04/05/2022 12:59 PM",
        CreatedBy: "SESAdmin",
        ActivityDate: "04/05/2022 12:59 PM",
        ActivityStatus: "NPI Completed",
        ActivityType: "User Account Updated",
        DateTimeDeleted: "04/05/2022 12:59 PM",
        DeletedReason: "Cannot get through Experian",
        DeletedBy: "SESAdmin",
        Org: "Centene",
        MailboxSize: "300MB",
        FwdEmail: "steve_doe123@sestest.directaddress.com",
        StartDate: "04/05/2022 12:59 PM",
        EndDate: "--",
        FwdStatus: "Active",
        FileName: "PWN Sent Messages 7.19.21",
        ReportType: "Deleted Activity",
        StartedBy: "ajcservice2",
        DownloadStatus: "In Progress",
        Domain: "service2.directaddress.net",
        UploadType: "Add User",
        UploadStatus: "In Progress"
    },
];
